import React from 'react';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product);
    toast.success(`${product.name} adicionado ao carrinho!`);
  };

  return (
    <div
      className="bg-white rounded-2xl overflow-hidden border border-[#F3E8E3] hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-video w-full overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
          data-testid={`product-image-${product.id}`}
        />
      </div>
      <div className="p-6">
        <h3
          className="text-xl font-bold text-[#291014] mb-2"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
          data-testid={`product-name-${product.id}`}
        >
          {product.name}
        </h3>
        <p
          className="text-sm text-[#5C4247] mb-4"
          style={{ fontFamily: 'Manrope, sans-serif' }}
          data-testid={`product-description-${product.id}`}
        >
          {product.description}
        </p>
        <div className="flex items-center justify-between">
          <span
            className="text-2xl font-bold text-[#7F1D1D]"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid={`product-price-${product.id}`}
          >
            R$ {product.price.toFixed(2)}
          </span>
          <Button
            onClick={handleAddToCart}
            className="bg-[#7F1D1D] hover:bg-[#991B1B] text-white rounded-full px-6"
            data-testid={`add-to-cart-button-${product.id}`}
          >
            <Plus className="h-4 w-4 mr-2" />
            Adicionar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;